module.exports = __webpack_public_path__ + "1.5.0-unryo/img/manage.6c246342.jpg";